import { Wedding } from "../../types/wedding";
import { generateAPI } from "../api.generator";

export const updateBrideAndGroomShorts = generateAPI<
  {
    body: {
      brideShortWords: string;
      brideImage: string;
      groomShortWords: string;
      groomImage: string;
    };
  },
  Wedding
>("put", "wedding/bride-and-groom-shorts", "wedding/");
